import { createPortalSlot } from '../PortalSlot';

const ResourceTabsSlot = createPortalSlot();
const ResourceActionsSlot = createPortalSlot();

export { ResourceActionsSlot, ResourceTabsSlot };
